import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';

import { Assignment } from '@material-ui/icons';

import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';

import { WithApp } from 'contexts/appContext';
import { Switch } from '@material-ui/core';
import RegularButton from 'components/CustomButtons/Button';
import { formatDate } from 'hooks/Pipe';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
});

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false },
  { Header: 'Código', accessor: 'code' },
  { Header: 'Zona', accessor: 'base_zone_description' },
  { Header: 'Mesa', accessor: 'base_bureau_description' },
  { Header: 'Descripción', accessor: 'description' },
  { Header: 'Inicio de operación', accessor: 'start_operation_day' },
  { Header: 'Estado', accessor: 'state' },
  { Header: 'Asignar Cartera', accessor: 'bureauSeller' },
  { Header: '', accessor: 'actions', excelEnabled: false },
];

export default WithApp(function Seller(props) {
  const classes = useStyles();
  const { supervisor, updateState, updatePortfolioSellerBureau, regenerate } = props;

  return (
    <GridItem xs={12}>
      <GridItem xs={12}>
        <RegularButton color="warning" onClick={regenerate}>
          Regenerar
        </RegularButton>
      </GridItem>
      <Card>
        <CardHeader icon>
          <CardIcon color={props.themeContext.buttonColor}>
            <Assignment />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>Listado de Vendedores</h4>
        </CardHeader>
        <CardBody>
          <ReactTable
            excelName={'Supervisor-vendedores-' + supervisor.dni}
            defaultWidth={1200}
            indexRow={[0, 1, 8]}
            widthRow={[100, 120, 5]}
            columns={columns}
            data={
              supervisor.sellers?.map((item, i) => {
                return {
                  num: i + 1,
                  code: item.SlpCode,
                  base_zone_description: supervisor.zones.find(
                    (x) => x.id == item.pivot.base_zone_id,
                  )?.description,
                  base_bureau_description: supervisor.bureaus.find(
                    (x) => x.id == item.pivot.base_bureau_id,
                  )?.description,
                  description: item.SlpName,
                  start_operation_day: !!item.work_day?.start_operation_at ? formatDate(item.work_day?.start_operation_at) : '-',
                  state: (
                    <Switch
                      checked={item.pivot.state === 'A' ? true : false}
                      onChange={() =>
                        updateState('seller', item.id, {
                          base_bureau_id: item.pivot.base_bureau_id,
                          state: item.pivot.state === 'A' ? 'I' : 'A',
                        })
                      }
                      color="secondary"
                    />
                  ),
                  bureauSeller: (
                    <Switch
                      checked={String(supervisor.base_portfolio_seller_id) === String(item.oauth_user_id)}
                      disabled={
                        supervisor.base_portfolio_seller_id !== null &&
                        String(supervisor.base_portfolio_seller_id) !== String(item.oauth_user_id)
                      }
                      onChange={() => {
                        const isActive = String(supervisor.base_portfolio_seller_id) === String(item.oauth_user_id);

                        updatePortfolioSellerBureau('seller', item.oauth_user_id, {
                          base_bureau_id: isActive ? null : item.pivot.base_bureau_id,
                          portfolio: 'Y',
                          statePortfolio: isActive ? 'I' : 'A',
                        });
                      }}
                      color="secondary"
                    />
                  ),
                  actions: '',
                };
              }) || []
            }
          />
        </CardBody>
      </Card>
    </GridItem>
  );
});
